import isEmpty from 'lodash/isEmpty';
import { LOAD_CONFIG_DATA_MODEL_SUCCESS } from '../../../actions/app/index.tsx';
import type { Action } from '../../../types.tsx';
import type { TrackingEntityState } from './types.tsx';

const defaultState: TrackingEntityState = {
	name: '',
	typeId: '',
	fieldId: '',
	isValid: false,
	isEnabled: false,
};

export const trackingReducer = (
	state: TrackingEntityState = defaultState,
	action: Action,
): TrackingEntityState => {
	if (action.type === LOAD_CONFIG_DATA_MODEL_SUCCESS) {
		if (isEmpty(action?.payload?.entities?.tracking)) return state;

		return action.payload.entities.tracking;
	}

	return state;
};
